"use client";

import { useEffect } from "react";
import Script from "next/script";
import { initGA, initPixel } from "@/lib/analytics";

const GA_ID = process.env.NEXT_PUBLIC_GA_MEASUREMENT_ID;
const PIXEL_ID = process.env.NEXT_PUBLIC_META_PIXEL_ID;

/**
 * Mounts once in app/layout.tsx. Injects the GA4 + Meta Pixel vendor
 * scripts via next/script (afterInteractive) and initializes the queues
 * via useEffect so any helper called before the vendor scripts finish
 * loading still gets queued onto dataLayer / fbq.queue.
 *
 * Both legs are gated on the corresponding env var — leaving either blank
 * is the same as not enabling that provider.
 */
export function AnalyticsBootstrap() {
  useEffect(() => {
    initGA(GA_ID);
    initPixel(PIXEL_ID);
  }, []);

  return (
    <>
      {GA_ID && (
        <Script
          src={`https://www.googletagmanager.com/gtag/js?id=${GA_ID}`}
          strategy="afterInteractive"
        />
      )}
      {PIXEL_ID && (
        <Script
          src="https://connect.facebook.net/en_US/fbevents.js"
          strategy="afterInteractive"
        />
      )}
      {PIXEL_ID && (
        <noscript>
          {/* eslint-disable-next-line @next/next/no-img-element */}
          <img
            height="1"
            width="1"
            style={{ display: "none" }}
            alt=""
            src={`https://www.facebook.com/tr?id=${PIXEL_ID}&ev=PageView&noscript=1`}
          />
        </noscript>
      )}
    </>
  );
}
